export enum ESearchType {
  ALPHABETICAL = 'alphabetical',
  SMILES = 'smiles',
}
